module.exports = function () {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: (scope, elem, attr, ngModel) => {
            // For DOM -> model validation
            ngModel.$parsers.unshift((value) => {
                scope.existingText = attr.wowMatchExistingTextValidator ? JSON.parse(attr.wowMatchExistingTextValidator) : [];
                const valid = scope.existingText.filter(text => text.toLowerCase() === value.toLowerCase()).length === 0;
                ngModel.$setValidity('matchExisting', valid);
                return valid ? value : undefined;
            });

            // For model -> DOM validation
            ngModel.$formatters.unshift((value) => {
                scope.existingText = attr.wowMatchExistingTextValidator ? JSON.parse(attr.wowMatchExistingTextValidator) : [];
                const valid = scope.existingText.filter(text => text.toLowerCase() === value.toLowerCase()).length === 0;
                ngModel.$setValidity('matchExisting', valid);
                return value;
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/common/matchexistingtextvalidator/match-existing-text-validator.directive.js